export const fetchRecords = (apiCall, successAction, q, page = 1, perPage, sortOpts, extraFilters) => (dispatch) =>
  apiCall(q, page, perPage, sortOpts, extraFilters).then((response) => {
    dispatch(successAction(response.records, page, response.pageCount, response.recordCount, perPage));
    return Promise.resolve(response);
  });

export const createRecord = (apiCall, payload) => () =>
  apiCall(payload).then((response) => {
    return Promise.resolve(response);
  });

export const updateRecord = (apiCall, payload) => () =>
  apiCall(payload).then((response) => {
    return Promise.resolve(response);
  });

export const deleteRecord = (apiCall, recordId) => () =>
  apiCall(recordId).then((response) => {
    return Promise.resolve(response);
  });
